import jApi from './jApi';

export default {
  getListPosition(req) {
    const api = jApi.generateApi();
    return api.post('jojoflow/organigram/list', req)
      .then(res => res);
  },

  getDetailPosition(req) {
    const api = jApi.generateApi();
    return api.post('jojoflow/organigram/detail', req)
      .then(res => res.data);
  },

  createPosition(req) {
    const api = jApi.generateApi();
    return api.post('jojoflow/organigram/create', req)
      .then(res => res.data);
  },

  updatePosition(req) {
    const api = jApi.generateApi();
    return api.post('jojoflow/organigram/update', req)
      .then(res => res.data);
  },

  deletePosition(req) {
    const api = jApi.generateApi();
    return api.post('jojoflow/organigram/delete', req)
      .then(res => res.data);
  },

  importPosition(req) {
    const api = jApi.generateApi();
    return api.post('jojoflow/organigram/import/r1', req, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then(res => res.data);
  },

  // parent
  getListParent(req) {
    const api = jApi.generateApi();
    return api.post('jojoflow/organigram/list', req)
      .then(res => res.data);
  },

  // division
  getListDivisions(req) {
    const api = jApi.generateApi();
    return api.post('jojoflow/setup/division/list', req)
      .then(res => res.data);
  },

  // create division
  createDivision(req) {
    const api = jApi.generateApi();
    return api.post('jojoflow/setup/division/create', req)
      .then(res => res.data);
  },

  // layer
  getListLayer(req) {
    const api = jApi.generateApi();
    return api.post('jojoflow/setup/layer/list', req)
      .then(res => res.data);
  },

  // create layer
  createLayer(req) {
    const api = jApi.generateApi();
    return api.post('jojoflow/setup/layer/create', req)
      .then(res => res.data);
  },

  // employee
  getListEmployee(req) {
    const api = jApi.generateApi();
    return api.post('user/employee/list-with-pagination', req)
      .then(res => res.data);
  },

  // employee temp
  getListEmployeeTemp(req) {
    const api = jApi.generateApi();
    return api.post('jojoflow/setup/layer/get-user-by-level', req)
      .then(res => res.data);
  },

  // rule
  getListRule(req) {
    const api = jApi.generateApi();
    return api.post('jojoflow/rule/list', req)
      .then(res => res.data);
  },

  // create employee
  createEmployee(req) {
    const api = jApi.generateApi();
    return api.post('user/employee/create', req)
      .then(res => res.data);
  },

  getDetailOrganigramTemp(req) {
    const api = jApi.generateApi();
    return api.post('jojoflow/setup/organigram-temp/detail/organigram-id', req)
      .then(res => res.data).catch((err) => {
        throw err;
      });
  },

  deleteOrganigramTemp(req) {
    const api = jApi.generateApi();
    return api.post('jojoflow/setup/organigram-temp/delete', req)
      .then(res => res.data);
  },

  createOrganigramTemp(req) {
    const api = jApi.generateApi();
    return api.post('jojoflow/setup/organigram-temp/create', req)
      .then(res => res.data);
  },

  companyListLocation(req) {
    const api = jApi.generateApi();
    return api.post('company/setup/location/list', req)
      .then(res => res.data);
  },

  getCoattendanceMappingRule(req) {
    const api = jApi.generateApi();
    return api.post('times/co-attendances/config/related-rule/list', req)
      .then(res => res.data);
  },

  createCoattendanceMappingRule(req) {
    const api = jApi.generateApi();
    return api.post('times/co-attendances/config/related-rule/create', req)
      .then(res => res.data);
  },

  updateCoattendanceMappingRule(req) {
    const api = jApi.generateApi();
    return api.post('times/co-attendances/config/related-rule/update', req)
      .then(res => res.data);
  },
};



// WEBPACK FOOTER //
// ./src/services/jApiPosition.js